import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip,
} from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningIcon from "@mui/icons-material/Warning";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

const TabClinicalInfo = ({ patient }) => {
  const getFlagChip = (value) => {
    if (value === "Yes" || value === true) {
      return <Chip label="Yes" color="success" size="small" />;
    } else if (value === "No" || value === false) {
      return <Chip label="No" color="default" size="small" />;
    } else {
      return <Chip label="N/A" color="warning" size="small" />;
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        🩺 Clinical Information
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <DirectionsRunIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>Discharged:</strong>{" "}
            {getFlagChip(patient?.discharged)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <LocalHospitalIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>Admitted:</strong>{" "}
            {getFlagChip(patient?.admitted)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <HighlightOffIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>Emergency:</strong>{" "}
            {getFlagChip(patient?.emergency)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <WarningIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>High Risk:</strong>{" "}
            {getFlagChip(patient?.highRisk)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <MonetizationOnIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>High Cost:</strong>{" "}
            {getFlagChip(patient?.highCost)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <AssignmentIndIcon
              fontSize="small"
              sx={{ verticalAlign: "middle", mr: 1 }}
            />
            <strong>Profile Patient:</strong>{" "}
            {getFlagChip(patient?.profile)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TabClinicalInfo;
